var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUser3 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 9.22754C11.3196 9.22754 13.2 7.32475 13.2 4.97754C13.2 2.63033 11.3196 0.727539 9 0.727539C6.6804 0.727539 4.8 2.63033 4.8 4.97754C4.8 7.32475 6.6804 9.22754 9 9.22754Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.2 10.4418H10.8C12.7096 10.4418 14.5409 11.2094 15.8912 12.5758C17.2414 13.9421 18 15.7952 18 17.7275H0C0 15.7952 0.758569 13.9421 2.10883 12.5758C3.45909 11.2094 5.29044 10.4418 7.2 10.4418Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUser3);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/user-3.0fc667e41656a673526e33b3d173c899.svg";